import React from 'react';
import DatesPicker from '../../../../components/DatesPicker/DatesPicker';
import styles from './styles.module.css';

const CYCLES = ['day', 'week', 'month'];

export default function DashboardHistoricalSelector({ cycleValue, onChange}) {
  return (
    <div>
      <div className={styles.historicalWrapper}>
        {CYCLES.map(cycle => (
          <button
            className={`${styles.cycleBtn} ${
              cycleValue === cycle ? styles.cycleBtnActive : ''
            }`}
            onClick={() => onChange(cycle)}
          >
            {cycle}
          </button>
        ))}
        <DatesPicker />
      </div>
    </div>
  );
}
